const selectInitialState = {
  funnel: null,
  sql: '',
  error: '',
};

const select = (state = selectInitialState, action) => {
  switch (action.type) {
    case 'SELECT_FUNNEL':
    case 'UPDATE_FUNNEL_SUCCESS':
      return {
        ...state,
        funnel: action.funnel,
      };

    // Track of the following action isn't excess because
    // the action is also triggered on creation of a new funnel
    // and we need to reset the state in that case

    case 'EXPOSE_FUNNEL_QUERY_SUCCESS':
      return {
        ...state,
        error: '',
        sql: action.sql,
      };

    case 'SET_FUNNEL_EXPOSE_ERROR':
      return {
        ...state,
        sql: '',
        error: action.error,
      };

    case 'DELETE_FUNNEL_SUCCESS':
      return {
        ...state,
        funnel: null,
      };

    default:
      return state;
  }
};

export default select;

export const getSelected = (state) => state.funnel;
export const getFunnelSQL = (state) => state.sql;
export const getError = (state) => state.error;
